<template>
  <v-app :class="prefix">
    <v-app-bar
      hheight="70"
      app
      color="grey lighten-4"
      elevate-on-scroll>
      <v-container class="mx-auto py-0">
        <v-row class="align-center">
          <router-link :to="{ name: 'Landing' }" class="d-inline-flex align-center text-decoration-none">
            <img class="mr-1" :src="require('./assets/' + prefix + '/logo.png')" height="50" :alt="apptitle"/>
            <img
              v-show="!$vuetify.breakpoint.smAndDown"
              class="mr-3"
              :src="require('./assets/' + prefix + '/logo-bluspeed.png')"
              height="50"
              :alt="apptitle"/>
            <v-toolbar-title v-show="!$vuetify.breakpoint.smAndDown">
              <div class="title-style-pnb title-style-pnb">{{ apptitle }}</div>
              <div class="title-style-pnb subtitle-style-pnb">{{ appsubtitle }}</div>
            </v-toolbar-title>
          </router-link>
          <v-spacer></v-spacer>
          <!-- public -->
          <div v-if="usernik === ''">
            <v-btn
              small
              class="ml-0 px-1 ml-md-1 px-md-4 hover-class-style"
              text
              :to="{ name: 'Landing' }"
              exact
              active-class="active-class-style">
              Main
            </v-btn>
            <v-btn
              small
              class="ml-0 px-1 ml-md-1 px-md-4 hover-class-style"
              text
              :to="{ name: 'Contact' }"
              exact
              active-class="active-class-style">
              Kontak
            </v-btn>
            <v-divider vertical class="ml-1 ml-md-1" style="height: 16px;"></v-divider>
            <v-btn
              small
              class="ml-1 px-1 ml-md-1 px-md-4 hover-class-style"
              text
              :to="{ name: 'Login' }"
              exact
              active-class="active-class-style">
              Log in
            </v-btn>
          </div>
          <!-- private -->
          <div v-if="usernik !== ''">
            <v-btn
              icon
              :to="{ name: 'Landing' }"
              exact>
              <v-icon>home</v-icon>
            </v-btn>
            <v-btn
              icon
              :to="{ name: 'Home' }"
              exact>
              <v-icon>insert_chart</v-icon>
            </v-btn>
            <v-btn
              :to="btnsurat"
              icon
              exact>
              <v-badge left color="red" overlap v-if="notif.length">
                <template v-slot:badge>
                  <span>{{ notif.length }}</span>
                </template>
                <v-icon>
                  mdi-school
                </v-icon>
              </v-badge>
              <v-icon v-if="!notif.length">
                mdi-school
              </v-icon>
            </v-btn>
            <v-btn
              icon
              @click.stop="rightDrawer = !rightDrawer">
              <v-icon>menu</v-icon>
            </v-btn>
          </div>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-main class="my-5">
      <router-view/>
    </v-main>
    <v-navigation-drawer
      v-model="rightDrawer"
      temporary
      fixed
      right>
      <div>
        <v-list shaped>
          <v-list-item
            v-for="item in menunavshow"
            :key="item.title"
            link
            :to="item.to"
            exact>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
      <template v-slot:append v-if="tokenscr">
        <div class="pa-2">
          <v-btn outlined color="error" block @click="doLogout">Logout</v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-footer dark :color="maincolor">
      <v-col
        class="text-center"
        cols="12">
        &copy; {{ new Date().getFullYear() }} - <strong> Politeknik Negeri Bali</strong>
        <div>
          <code>{{ appname }}</code>
        </div>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import qs from 'qs';

export default Vue.extend({
  name: 'App',
  components: {
  },
  data: () => ({
    appname: process.env.VUE_APP_NAME,
    apptitle: process.env.VUE_APP_TITLE,
    appsubtitle: process.env.VUE_APP_SUBTITLE,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    modulklian: process.env.VUE_APP_MOD_KLIAN,
    rightDrawer: false,
    notif: [],
    btnsurat: {},
    menunav: [
      {
        title: 'Login',
        icon: 'lock',
        to: { name: 'Login' },
        role: ['public'],
      },
      {
        title: 'Beasiswa',
        icon: 'mdi-school',
        to: { name: 'SuratGuest' },
        role: ['mahasiswa'],
      },
      {
        title: 'Beasiswa',
        icon: 'mdi-school',
        to: { name: 'SuratDosen' },
        role: ['dosen-old'],
      },
      {
        title: 'Beasiswa',
        icon: 'mdi-school',
        to: { name: 'BeasiswaJur' },
        role: ['jurusan'],
      },
      {
        title: 'Beasiswa',
        icon: 'mdi-school',
        to: { name: 'SuratAdmin' },
        role: ['admin'],
      },
      {
        title: 'Cek Beasiswa',
        icon: 'playlist_add_check',
        to: { name: 'Check' },
        role: ['mahasiswa-surat', 'dosen-surat', 'admin-surat', 'public-surat'],
      },
      {
        title: 'Penduduk',
        icon: 'people_alt',
        to: { name: 'PendudukAdmin' },
        role: ['admin-desa'],
      },
      {
        title: 'Klian Banjar',
        icon: 'people_outline',
        to: { name: 'KlianbanjarAdmin' },
        role: ['admin-desa'],
      },
      {
        title: 'Jenis Beasiswa',
        icon: 'library_books',
        to: { name: 'JenissuratAdmin' },
        role: ['admin'],
      },
      {
        title: 'Jenis Pekerjaan',
        icon: 'work',
        to: { name: 'JeniskerjaAdmin' },
        role: ['admin-desa'],
      },
      {
        title: 'Kode Pos',
        icon: 'alternate_email',
        to: { name: 'KodeposAdmin' },
        role: ['admin-desa'],
      },
      {
        title: 'Banjar',
        icon: 'account_balance',
        to: { name: 'BanjarAdmin' },
        role: ['admin-desa'],
      },
      {
        title: 'Ubah Password',
        icon: 'lock_open',
        to: { name: 'Changepassword' },
        role: ['mahasiswa', 'dosen', 'jurusan', 'admin'],
      },
      {
        title: 'Kontak',
        icon: 'contact_support',
        to: { name: 'Contact' },
        role: ['mahasiswa', 'dosen', 'jurusan', 'admin', 'public'],
      },
      {
        title: 'Setting',
        icon: 'settings',
        to: { name: 'SettingAdmin' },
        role: ['admin-desa'],
      },
    ],
    menunavshow: [],
    publickey: '123',
    api: process.env.VUE_APP_API,
    prefix: process.env.VUE_APP_PREFIX,
    loading: {
      static: false,
    },
    deferredPrompt: null,
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'usernik',
      'userbanjar',
      'staticdata',
    ]),
  },
  created() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      // Stash the event so it can be triggered later.
      this.deferredPrompt = e;
    });
    window.addEventListener('appinstalled', () => {
      this.deferredPrompt = null;
    });
    this.$root.$on('app-getnotifiaction', () => {
      this.getNotifikasi();
    });
  },
  mounted() {
    // check tokensrc
    if (this.tokenscr && this.tokenscr !== '') {
      this.checkTokenscr();
    } else {
      // this.doLogout();
    }
    // update menu if not watch
    this.menuByRole();
    // notif
    this.getNotifikasi();
    // static data
    this.getStaticData();
  },
  methods: {
    async dismiss() {
      this.deferredPrompt = null;
    },
    async downloadApp() {
      this.deferredPrompt.prompt();
    },
    menuByRole() {
      console.log(this.userrole);
      this.menunavshow = [];
      for (const row of this.menunav) {
        if (this.userrole && this.userrole !== '') {
          if (row.role.indexOf(this.userrole) >= 0) {
            this.menunavshow.push(row);
          }
        } else {
          if (row.role.indexOf('public') >= 0) {
            this.menunavshow.push(row);
          }
        }
      }
      // btn surat
      this.btnsurat = { name: 'SuratGuest' };
      if (this.userrole === 'admin') {
        this.btnsurat = { name: 'SuratAdmin' };
      } else if (this.userrole === 'dosen') {
        this.btnsurat = { name: 'SuratDosen' };
      } else if (this.userrole === 'jurusan') {
        this.btnsurat = { name: 'BeasiswaJur' };
      }
    },
    getNotifikasi() {
      this.notif = [];
      if (this.tokenscr) {
        // data params
        const dataparam = {
          status: '\'permohonan\'',
          banjar: this.userbanjar,
        };
        if (this.userrole === 'klian') {
          dataparam.status = '\'accbanjar\'';
        } else if (this.userrole === 'user') {
          dataparam.status = '\'accbanjar\',\'permohonan\',\'proses\',\'siap\'';
        } else if (this.userrole === 'admin') {
          dataparam.status = '\'permohonan\',\'proses\'';
        }
        // request
        this.axios
          .get(
            this.api + '/api/surat/notification',
            {
              params: dataparam,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.notif = resdata.data;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    checkTokenscr() {
      this.axios
        .post(
          this.api + '/api/checktoken',
          qs.stringify(
            {
              token: this.tokenscr,
            },
          ),
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': 'bearer ' + this.tokenscr,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            if (resdata.error === true) {
              this.doLogout();
            }
          }
        })
        .catch((error) => {
          this.doLogout();
        });
    },
    doLogout() {
      this.$store.commit('AUTH_LOGOUT');
      this.$router.push({ name: 'Login' });
    },
    getStaticData() {
      this.loading.static = true;
      this.axios
        .post(
          this.api + '/public/' + this.prefix,
          qs.stringify(
            this.login,
          ),
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            if (resdata.error === false) {
              this.$store.commit('SET_STATICDATA', resdata.data);
            } else {
              console.log(resdata.message);
            }
          } else {
            console.log('Internal services error!');
          }
          this.loading.static = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading.static = false;
        });
    },
  },
  watch: {
    userrole(val) {
      this.menuByRole();
    },
    tokenscr(val) {
      this.getNotifikasi();
    },
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $main-color: #216185;
  $main-font: 'Nunito';
  $gray-table: rgba(0, 0, 0, 0.12);
  .title-style-pnb{
    font-family: $main-font !important;
    color: $main-color !important;
    font-weight: bold;
    line-height: normal !important;
  }
  .title-style-pnb{
    font-size: 26px;
  }
  .subtitle-style-pnb{
    font-size: 14px;
  }
  // Global
  .sangsit{
    font-family: 'Times New Roman', Times, serif !important;
  }
  /* map z-index issue */
  header{
    z-index: 1001 !important;
  }
  .v-overlay--active{
    z-index: 1002 !important;
  }
  .v-navigation-drawer--temporary {
    z-index: 1003 !important;
  }
  .v-dialog__content--active{
    z-index: 1004 !important;
  }
  /* text */
  .text-uppercase-input{
    input{
      text-transform: uppercase;
    }
  }
  .space-break{
    white-space: break-spaces !important;
  }
  // tabel
  .table-nowrap{
    table{
      white-space: nowrap !important;
    }
  }
  table.tbl-align-top{
    tr{
      vertical-align: top;
      td{
        padding: 5px;
      }
      td.min-first-colm{
        width: 160px;
        max-width: 50%;
      }
    }
  }
  // autocomppleted
  .chip-h-auto{
    height: auto !important;
  }
  .pdf-embed-custom{
    width: 850px;
    max-width: 100%;
    height: 110vh;
    margin: auto;
  }
  .img-detail-link{
    cursor: pointer;
  }
</style>
